/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlayerNoteCommand } from '../../models/create-player-note-command';
import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';

export interface ApiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params {
      body?: CreatePlayerNoteCommand
}

export function apiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingFalse$Any(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingFalse$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingFalse$Any.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=none;odata.streaming=false');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/octet-stream', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPost$JsonOdataMetadataNoneOdataStreamingFalse$Any.PATH = '/api/player-notes';
